module.exports = __webpack_public_path__ + "img/HealthHelp_InstantHealthCheck.413c4fcf.svg";